import { makeVar } from '@apollo/client'
import { InMemoryCache } from '@apollo/client'

export const userLoggedIn = makeVar(false);
export const activeMap = makeVar(null);

export const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          activeMap: { read() { return activeMap(); } },
          userLoggedIn: { read() { return userLoggedIn(); } },
        }
      }
    }
  });